export const MomRoomId = "c62544ad-c470-4af4-8a8e-a3f3983fcc7d";
export const CloneRoomId = "edec957f-f10c-4ba8-a7e1-2727dd638b53";
export const VegRoomId = "a02ede17-7aec-497b-99ce-c66e27a5ca81";
export const Flower1RoomId = "cf39f147-552c-4c94-86c6-af2f0c7a186c";
export const Flower2RoomId = "27863615-a3d2-4c21-9d10-98bb97d6ec10";
export const Flower3RoomId = "87437e1f-1242-424d-8db1-a65d150b7d46";
export const Flower4RoomId = "fdf2e5b4-7711-4b50-9100-f5e28e9e908b";
export const Harvest1RoomId = "380fcd31-f2e9-4c12-9120-26c38f33492b";
export const Harvest2RoomId = "30abea1c-bc3c-4145-ac58-1616be24239a";